import { render, staticRenderFns } from "./RoleSelection.vue?vue&type=template&id=bee97248&scoped=true"
import script from "./RoleSelection.vue?vue&type=script&lang=js"
export * from "./RoleSelection.vue?vue&type=script&lang=js"
import style0 from "./RoleSelection.vue?vue&type=style&index=0&id=bee97248&prod&scoped=true&lang=scss"
import style1 from "./RoleSelection.vue?vue&type=style&index=1&id=bee97248&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee97248",
  null
  
)

export default component.exports